export default {
    OrderPipelineViewer: 'Order Pipeline Viewer',
    OrderPipelineAdministrator: 'Order Pipeline Administrator',
    Admin: 'Orders Admin',
    Viewer: 'Orders Viewer'
}
